import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_465: DocMigration = {
  maxSchemaVersion: "0.0.465",
  description: "Invert viewport content rotation (rotation should be counter-clockwise)",
  apply(json: any): any {
    const viewports = json.viewports;

    if (viewports) {
      for (const viewportKey of Object.keys(viewports)) {
        const viewport = viewports[viewportKey];
        if (
          (viewport.viewType === "PLAN_VIEW" || viewport.viewType === "DRAWING") &&
          typeof viewport.contentRotationDegrees === "number"
        ) {
          viewport.contentRotationDegrees = -viewport.contentRotationDegrees;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_465;
